// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3X6Vy","name":"Header_name__2ufqF","birthday":"Header_birthday__kpodj","skeleton":"Header_skeleton__3I7We"};